<template>
	<div class="itv-datepicker__trigger-wrap">
		<input
			class="itv-datepicker__trigger"
			type="text"
			:placeholder="placeholder"
			v-model="output"
			@keypress="dateInputMask"
			@click="showDatepicker"
			maxLength="10"
			inputmode="numeric"
			:readonly="readonly"
			ref="trigger"
		/>
		<div v-if="value" class="itv-datepicker__clear">
			<btn-clear @click-event="clearDate" />
		</div>
	</div>
	<VueDatePicker
		v-model="value"
		locale="ru"
		:min-date="minDate"
		:max-date="maxDate"
		:start-date="startDate"
		:year-range="[1960, 2010]"
		:enable-time-picker="false"
		:month-change-on-scroll="false"
		:name="name"
		@date-update="activeBtn = true"
		ref="datepicker"
	>
		<template #action-buttons>
			<div class="itv-datepicker__btn">
				<primary-button
					:content="cancelBtn"
					@click-event="clearDate"
					:class="{ disabled: !activeBtn }"
				/>
			</div>
			<div class="itv-datepicker__btn">
				<primary-button
					:content="confirmBtn"
					@click-event="selectDate"
					:class="{
						disabled: !activeBtn,
					}"
				/>
			</div>
		</template>
	</VueDatePicker>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker7'
import '@vuepic/vue-datepicker7/dist/main.css'

import PrimaryButton from './PrimaryButton'
import BtnClear from './BtnClear'

export default {
	components: {
		VueDatePicker,
		PrimaryButton,
		BtnClear,
	},
	props: {
		minDate: {
			type: String,
			default: '',
		},
		maxDate: {
			type: String,
			default: '',
		},
		startDate: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: 'date',
		},
	},
	data() {
		return {
			type: 'text',
			value: null,
			placeholder: 'Дата рождения',
			output: this.onloadDate,
			readonly: false,
			confirmBtn: {
				btnColorType: 'green',
				text: 'Применить',
			},
			cancelBtn: {
				btnColorType: 'transparent',
				text: 'Сбросить',
			},
		}
	},
	methods: {
		clearDate() {
			this.activeBtn = false
			if (this.$refs.datepicker) {
				this.$refs.datepicker.clearValue()
			} else {
				this.value = null
			}

			this.output = null
			this.readonly = false
			this.$emit('change-date', this.value, null)
		},
		selectDate() {
			this.$refs.datepicker.selectDate()
			this.output = this.formatDate(this.value)

			this.readonly = true
			this.$emit('change-date', this.value, this.output)
		},

		formatDate(date, monthNumeric = false) {
			let monthFormat = 'long'
			if (monthNumeric) {
				monthFormat = 'numeric'
			}
			const options = {
				year: 'numeric',
				month: monthFormat,
				day: 'numeric',
			}

			return date.toLocaleString('ru', options)
		},

		showDatepicker() {
			this.$refs.datepicker.openMenu()
			this.$nextTick(() => this.$refs.trigger.focus())
		},

		dateInputMask(evt) {
			if (evt.key.length > 1 || evt.ctrlKey) return

			if (evt.keyCode === 13 || evt.key.match(/\d/)) {
				setTimeout(() => {
					switch (this.output.length) {
						case 1:
							if (this.output > 3) {
								this.output = '3'
							}
							break
						case 2:
							if (this.output > 31) {
								this.output = '31'
							}
							break
						case 3:
						case 4:
							if (this.output[2] !== '.') {
								this.output = this.output.substr(0, 2) + '.' + this.output[2]
							}
							if (this.output[3] > 1) {
								this.output = this.output.substr(0, 3) + '1'
							}
							break
						case 5:
							if (this.output.substr(3, 2) > 12) {
								this.output = this.output.substr(0, 3) + '12'
							}
							break
						case 6:
						case 7:
							if (this.output[5] !== '.') {
								this.output = this.output.substr(0, 5) + '.' + this.output[5]
							}
							if (this.output[6] < 1) {
								this.output = this.output.substr(0, 6) + '1'
							}
							if (this.output[6] > 2) {
								this.output = this.output.substr(0, 6) + '2'
							}
							break
						case 10:
							const splitDate = this.output.split('.')
							const day = splitDate[0]
							const month = splitDate[1] - 1
							const year = splitDate[2]
							this.value = new Date(year, month, day)
							this.selectDate()
							this.$refs.datepicker.closeMenu()
							break
						default:
							break
					}
				}, 0)
				return
			}

			evt.preventDefault()
		},
	},
}
</script>
